import { setSessionItem, getSessionItem } from "./chatUtility";

// Return current timestamp in seconds
function get_currentTime() {
  return Math.floor(new Date().getTime() / 1000);
}

// Sets the session storage timestamp to the current time
function update_lastMsg() {
  var time = get_currentTime();
  set_timeOutFlag("none");
  setSessionItem("lastMsgTime", JSON.stringify(time));
}

// Returns time in seconds since last reply was recieved from dialogflow
function time_since_lastMsg() {
  if (getSessionItem("chatType") !== "df") {
    sessionStorage.removeItem("lastMsgTime");
  }

  if (getSessionItem("lastMsgTime")) {
    var lastMsg = JSON.parse(getSessionItem("lastMsgTime"));
    var currentTime = get_currentTime();
    var time_diff = currentTime - lastMsg;

    //console.log(`time since last message is: ${time_diff}`)
    return time_diff;
  } else {
    //console.log("no messages have been recieved from DF")
    return 0;
  }
}

// The Time Out Flag keeps track of whether the user has been warned and if the chat session has timed out.
function set_timeOutFlag(val) {
  setSessionItem("timeOutFlag", val);
}

function get_timeOutFlag() {
  if (getSessionItem("timeOutFlag")) {
    return getSessionItem("timeOutFlag");
  } else {
    return "none";
  }
}

export {
  get_currentTime,
  update_lastMsg,
  time_since_lastMsg,
  set_timeOutFlag,
  get_timeOutFlag
};
